import angular from 'angular';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.order.delivery", [
]).controller("merchant.application.module.order.delivery", [
    "$scope", "$controller",
    function($scope, $controller) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.orderDelivery) {
            $scope.model.orderDelivery = {};
        }

        $scope.isInStoreOrder = function() {
            return (
                $scope.model.orderDelivery &&
                $scope.model.orderDelivery.channel &&
                $scope.model.orderDelivery.channel === "IN_STORE"
            ) ? true : false;
        };

        $scope.showMap = function() {
            $scope.model.modulesIncludedInModal = ["map.html"];
            $scope.model.isModalVisible = true;
        };

    }
]);
